import { useSyncExternalStore } from 'react';

// Tailwind's `lg` breakpoint. Use this (not the md-based useIsDesktop) when a
// decision must match a `lg:`-gated layout — e.g. a panel that only docks at lg.
const LG_QUERY = '(min-width: 1024px)';
// jsdom has no matchMedia, and neither does the server. Both answer "not large"
// — the narrow layout works at every width, so it is the safe thing to fall
// back to when nobody can tell us how wide the page is.
const mediaQuery = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(LG_QUERY)
    : null;
const subscribe = (cb: () => void) => {
  const mql = mediaQuery();
  if (!mql) return () => {};
  mql.addEventListener('change', cb);
  return () => mql.removeEventListener('change', cb);
};
const getSnapshot = () => mediaQuery()?.matches ?? false;
const getServerSnapshot = () => false;

export function useIsLargeScreen() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
